import {Component} from "react";
import * as React from "react";

class AccordionSet extends Component {

    render() {
        return <div className="accordion-set" data-automation="submit-watch" >{this.props.children}</div>
    }
}

export {AccordionSet}